import { Fragment } from 'react';

import useGroupCompetitorListMembers from './UseGroupCompetitorListMembers';

import CompetitorListGroupMemberGrid from '../../components/grids/CompetitorListGroupMemberGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { SAVING_MSG } from '@usas/ui-web/utils/Constants';

const GroupCompetitorListMembers = () => {
  const {
    isLoading,
    isSaving,
    gridData,
    modalState,
    onInviteAlternateClicked,
    onAddMemberToGroupClicked,
    onEditGroupMemberClicked,
    onDeleteGroupMemberClicked,
    onDeleteModalConfirmClicked,
    onDeleteModalCancelClicked
  } = useGroupCompetitorListMembers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Competitor List Group Members</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className='col-xs-12 usas-extra-top-margin'>
          <ActionIntraPageButton onClick={onAddMemberToGroupClicked}>Add Member to Group</ActionIntraPageButton>&nbsp;
          <ActionIntraPageButton onClick={onInviteAlternateClicked}>Invite Alternate</ActionIntraPageButton>
        </div>
      </div>
      <div className='row'>
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <CompetitorListGroupMemberGrid
            data={gridData}
            isLoading={isLoading}
            onEditClicked={onEditGroupMemberClicked}
            onDeleteClicked={onDeleteGroupMemberClicked} />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Remove Group Member?'}
        displayPopUp={modalState.displayModal}
        onModalCanceled={onDeleteModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>Member:</b> {modalState.firstName} {modalState.lastName}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onDeleteModalConfirmClicked}>Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onDeleteModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupCompetitorListMembers;